import { combineEpics } from 'redux-observable';

import {
	LoginEpic,
	ValidateOtpEpic,
	PreCheckEpic,
	ResendOtpEpic,
	PinEpic,
	NavigateCodeEpic,
	ValidateEmailEpic,
	TNCEpic
} from '../redux/epics';

export default combineEpics(
	PreCheckEpic,
	LoginEpic,
	ValidateOtpEpic,
	ResendOtpEpic,
	PinEpic,
	NavigateCodeEpic,
	ValidateEmailEpic,
	TNCEpic
);
